<template>
  <footer>
    <v-row class="copyright_wrap">      
      <div class="copyright_inner">        
        <v-col class="footer_icon d-flex align-center">
          <v-img style="max-width:63px;" src="~@/assets/img/footer_icon01.png"/>          
          <v-img style="max-width:69px;" src="~@/assets/img/footer_icon02.png"/>          
        </v-col>
        <v-col class="copy__text" v-html="$t('view.FOOTER.KOICA')">
          <p>This system has been implemented by the grant of the government of the Republic of Korea.</p>
          <p>Copyright  ⓒ 2020 Siriussoft Co., Ltd. All Rights Reserved.</p>
        </v-col>                
        <v-col class="footer_text_icon d-flex align-center">
          <div class="ft__text__icon" v-html="$t('view.FOOTER.eService')" @click="open('egpo-e-service')">
            EGPO<br>e-Service
          </div>
          <div class="ft__text__icon" v-html="$t('view.FOOTER.EGPOHome')" @click="open('egpo-homepage')">
            EGPO<br>HOMEPAGE
          </div>
        </v-col>
      </div>
    </v-row>
  </footer>   
</template>

<script>
export default {
  name: 'Footer',
  components: {},
  data: () => ({
    //
  }),
  methods: {
    open(name) {
      if(name === 'egpo-e-service') {
        window.open(this.config.E_SERVICE_URL, '_blank');
      } else if(name === 'egpo-homepage') {
        window.open(this.config.HOMEPAGE_URL, '_blank');
      }
    },
  }
};
</script>
